module.exports = __webpack_public_path__ + "img/right-frame.921a51fd.png";